import React, { useEffect, useState } from "react";
import { apiFetch as fetch } from "apiClient";

const formatUtcToLocal = (utcString) => {
    if (!utcString) return "-";
    const d = new Date(utcString);
    return d.toLocaleString(undefined, {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
};

export default function ScheduledJobsPanel() {
    const [rows, setRows] = useState([]);

    async function fetchData() {
        const res = await fetch("/api/monitoring/scheduled/status", { credentials: "include" });
        setRows(await res.json());
    }

    useEffect(() => {
        fetchData();
        const id = setInterval(fetchData, 10000);
        return () => clearInterval(id);
    }, []);

    const chip = (label, kind) => (
        <span className={`chip ${kind === "ok" ? "chip--idle" : kind === "warn" ? "chip--running" : "chip--failed"}`}>{label}</span>
    );

    return (
        <div className="card">
            <div className="row mb-4"><h3 className="h3">Scheduled Jobs</h3></div>
            <div className="table-wrap">
                <table className="table table--zebra table--sticky">
                    <thead>
                    <tr>
                        <th>Job</th><th>Cadence</th><th>Earliest</th>
                        <th>Last Run (date)</th><th>Last Run (time, local)</th>
                        <th>Today?</th><th>Due Now?</th><th>Note</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rows.length === 0 ? (
                        <tr><td colSpan={8}>No data.</td></tr>
                    ) : rows.map(r => {
                        const lastRunTime = r.appLastRunAt ? formatUtcToLocal(r.appLastRunAt) : "-";
                        const todayChip = r.ranTodayByApp ? chip("Ran", "ok") : chip("Not yet", "warn");
                        const dueChip = r.dueNow ? chip("Due", "warn") : chip("Not due", "ok");
                        const displayLabel = r.displayName || r.jobName;

                        return (
                            <tr key={r.jobName}>
                                <td>
                                    {displayLabel}
                                </td>
                                <td className="mono">{r.cadence}</td>
                                <td className="mono">{r.earliestTime}</td>
                                <td className="mono">{r.appLastRunDate || "-"}</td>
                                <td className="mono">{lastRunTime}</td>
                                <td>{todayChip}</td><td>{dueChip}</td>
                                <td className="note">{r.note}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
